<template>
  <div class="order-saved-screen">
    <img class="order-saved-screen__img" src="~@/assets/order-complete.svg" />
    <div class="order-saved-screen__title">{{ $t("page.order.confirmation.successmessage") }}</div>

    <div class=".deliveryTypes">
      <div v-for="deliveryType in supportedDeliveryTypes" :key="deliveryType.id" >
        <label class="label">{{ $t(deliveryType.deliveryTypeOrderNumberTranslationKey) }}</label>
        <div class="value">{{ basicData.temporaryOrderNumber }} {{ deliveryType.orderNumberPostfix }}</div>
      </div>
      <div>
        <label class="label">{{ $t("page.order.confirmation.onholdordernumber") }}</label>
        <div class="value">{{ basicData.temporaryOrderNumber }} H</div>
      </div>
    </div>

    <div class="order-saved-screen__btns">
      <v-button
        id="export-list-button"
        class="ml-auto mr-20 button--white-border"
        @click="startExcelDownload"
        :loading="downloadExcellInProgress"
      >
        <i class="icon-export mr-10"></i>
        {{ $t("page.order.confirmation.exportlist") }}
      </v-button>

      <v-button
        id="start-new-order-button"
        primary
        class="pv-20"
        :disabled="downloadExcellInProgress"
        @click.prevent="$router.push({ name: 'myPills' })"
      >
        <i class="icon-document mr-10"></i>
        {{ $t("page.order.confirmation.startneworder") }}
      </v-button>
    </div>
  </div>
</template>

<script>
import { VButton } from "shared";
import * as OrdersDAO from "@/dao/order-dao";
import * as DownloadUtils from "@/utils/DownloadUtils";
import * as PromiseUtils from "@/utils/PromiseUtils";
import { mapGetters } from "vuex";

export default {
  name: "VOrderSavedScreen",
  components: {
    VButton
  },
  data() {
    return {
      downloadExcellInProgress: false
    };
  },
  props: {
    orderId: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters("order", ["basicData", "deliveryTypes"]),
    supportedDeliveryTypes() {
      return this.deliveryTypes.filter(dt => dt.displayOrderNumber);
    }
  },
  methods: {
    async startExcelDownload() {
      this.downloadExcellInProgress = true;
      const { requestId } = await OrdersDAO.startExcelDownload(this.orderId);

      let downloadedExcelFile = await OrdersDAO.getDownloadedExcel(this.orderId, requestId);
      while (downloadedExcelFile.status !== "success") {
        await PromiseUtils.delay(2000); // eslint-disable-line
        downloadedExcelFile = await OrdersDAO.getDownloadedExcel(this.orderId, requestId);
      }

      const url = downloadedExcelFile.url;
      await DownloadUtils.downloadFile(url);
      this.downloadExcellInProgress = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";
.order-saved-screen {
  text-align: center;
  padding: 91px 0 0 0;
  &__title {
    margin: 35px auto;
    font-size: 24px;
    max-width: 300px;
    letter-spacing: 0.8px;
  }
  &__btns {
    margin: 0 0 0 0;
    .button {
      &--white {
        padding: 12px 23px;
        margin: 5px;
        letter-spacing: 0;
      }
    }
  }
}
.label {
  color: #999999;
  font-size: 13px;
}
.deliveryTypes{
  display:flex;
  align-items: center;
  justify-content: center;
  margin:25px;
}
</style>
